import { ComponentName } from '@constants';
import { enableModal } from '@state/reducers/modals.ts';
import {
  setDepositThresholdInfo,
  setDisableLogoutModal,
  setLogout,
} from '@state/reducers/user.ts';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSocket } from '../../containers/websocket-provider.tsx';

export function WebSocketClientChangedWatcher() {
  const { getLatest } = useSocket();
  const dispatch = useDispatch();
  const changed = getLatest('client_changed');
  const isLogoutMessageModalEnabled =
    window.__config__.componentSettings?.logout?.logoutMessageModalEnabled ||
    false;
  const lastEventKeyRef = useRef<string | number | null>(null);

  useEffect(() => {
    if (changed) {
      // @ts-ignore
      const eventKey = `${changed.action}:${changed.data?.player_id ?? 'unknown'}`;

      if (lastEventKeyRef.current === eventKey) return;
      lastEventKeyRef.current = eventKey;
      // @ts-ignore
      if (changed.data.current !== navigator.userAgent) {
        if (isLogoutMessageModalEnabled) {
          dispatch(enableModal(ComponentName.LogoutMessageModal));
        }
        dispatch(setLogout());
      }
    }
  }, [dispatch, changed, isLogoutMessageModalEnabled]);

  return null;
}
